const $ = require("jquery");
import { updateContent } from "../global/update-content.js";

$(document).ready(function() {
  $(
    "body.page-template-educations-mbo .filter__select, body.post-type-archive .filter__select"
  ).on("change", function(e) {
    e.preventDefault();

    const name = $(this).attr("name");
    const val = $(this).val();

    updateContent(name, val);
  });
});
